export interface NavigationItem {
  path: string
  label: string
  icon: string
  badge?: number
  permission?: string
  permissionsAny?: string[]
}

export interface NavigationGroup {
  title?: string
  items: NavigationItem[]
}

export function activeNavigationPath(path: string): string {
  if (path.startsWith('/reports/patients/')) return '/report-files'
  if (path.startsWith('/patients/')) return '/patients'
  if (path.startsWith('/daily-checkin')) return '/daily-checkin'
  if (path.startsWith('/questionnaire-center')) return '/questionnaire-center'
  if (path.startsWith('/questionnaires')) return '/questionnaires'
  if (path.startsWith('/consultations')) return '/consultations'
  return path
}

export const navigationGroups: NavigationGroup[] = [
  {
    title: '患者管理',
    items: [
      { path: '/patients', label: '患者列表', icon: 'User', permission: 'patient:read' },
      { path: '/report-files', label: '全部报告', icon: 'FolderOpened', permission: 'report:read' },
    ],
  },
  {
    title: '八维归因配置',
    items: [
      { path: '/attribution', label: '八维归因评分规则', icon: 'Aim', permission: 'attribution:read' },
      { path: '/assessment-indicators', label: '八维归因指标配置', icon: 'DataAnalysis', permission: 'attribution:read' },
      { path: '/ivf-phases', label: '试管阶段配置', icon: 'Calendar', permission: 'attribution:read' },
    ],
  },
  {
    title: '服务流程',
    items: [
      { path: '/meds', label: '药品配置', icon: 'FirstAidKit', permission: 'medication:read' },
    ],
  },
  {
    title: '内容运营',
    items: [
      { path: '/daily-checkin', label: '每日打卡', icon: 'Tickets', permission: 'checkin:read' },
      { path: '/questionnaire-center', label: '问卷中心', icon: 'Document', permission: 'questionnaire:read' },
      {
        path: '/questionnaires',
        label: '模板管理',
        icon: 'Reading',
        permissionsAny: ['questionnaire:read', 'checkin:read'],
      },
      { path: '/consultations', label: '咨询管理', icon: 'ChatDotRound', permission: 'consultation:read' },
    ],
  },
  {
    title: '角色权限',
    items: [
      { path: '/accounts', label: '用户管理', icon: 'User', permission: 'identity:account-read' },
      { path: '/roles', label: '角色管理', icon: 'Avatar', permission: 'identity:role-read' },
    ],
  },
  {
    title: '系统运维',
    items: [
      { path: '/operations/third-party', label: '第三方服务', icon: 'Connection', permission: 'operations:third-party-read' },
    ],
  },
  {
    title: '审计',
    items: [
      { path: '/audit', label: '操作日志', icon: 'DocumentChecked', permission: 'audit:read' },
    ],
  },
]
